// 有时候我们需要从 store 中的 state 中派生出一些状态
export const userInfo = state => {
  // const name = localStorage.getItem("currentUser_name")
  // const auth = localStorage.getItem("token")


  return state.user;
}
//
export const hospital = state => {
  return state.userInfo &&　state.userInfo.professional && state.userInfo.professional.companies　&&　state.userInfo.professional.companies[0] && state.userInfo.professional.companies[0].companyName || ""
}
export const hospitalId = state => {
  return state.userInfo &&　state.userInfo.professional && state.userInfo.professional.companies　&&　state.userInfo.professional.companies[0] && state.userInfo.professional.companies[0].companyId || ""
}

export const school = state => {
  return state.userInfo &&　state.userInfo.professional && state.userInfo.professional.educations[0] && state.userInfo.professional.educations[0].universityName || ""
}
